import { render, staticRenderFns } from "./verPurOrders.vue?vue&type=template&id=f0c89a8e&"
import script from "./verPurOrders.vue?vue&type=script&lang=js&"
export * from "./verPurOrders.vue?vue&type=script&lang=js&"
import style0 from "./verPurOrders.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "verPurOrders.vue"
export default component.exports